module.exports = __webpack_public_path__ + "img/v4_td2.782ee0c4.png";